import { Button } from '@ab-inbev-maz/compass';
import { Link, useRouteError } from 'react-router-dom';

const ErrorPage = () => {
  const error = useRouteError() as Error;

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-100 to-orange-100 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        <div className="text-6xl mb-4">😵</div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          ¡Oops! Algo salió mal
        </h1>
        
        <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 text-left">
          <h3 className="font-bold text-red-800 mb-2">Error:</h3>
          <p className="text-red-700 text-sm">
            {error?.message || 'Ha ocurrido un error inesperado'}
          </p>
        </div>
        
        <div className="space-y-3">
          <Link to="/" className="block">
            <Button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg w-full">
              🏠 Volver al inicio
            </Button>
          </Link>
          
          <Button 
            onClick={() => window.location.reload()}
            className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded-lg w-full"
          >
            🔄 Recargar página
          </Button>
        </div>
        
        <div className="mt-6 text-sm text-gray-600">
          <p>Si el problema persiste, contacta al soporte técnico.</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
